import React from "react";
import CampaignGroups from "../../client_config/ppc_config/CampaignGroups"

export default function Search(props) {
  
  const searchCampaignGroups = props.campaignGroups.search
  const allCampaignGroups = props.campaignGroups

  return (
   <div style={{backgroundColor:"#F5F5F5"}}>
 
    <CampaignGroups {...props} platformType="Search" campaignGroups={searchCampaignGroups} allCampaignGroups={allCampaignGroups} setCampaignGroups={props.setCampaignGroups} onboarding />
   </div>
  
  );
}